// The panel's context key, under which the session of a finished KPI report is listed (PLAN-076). Mirrors the backend
// KpiReportSessionRequestDTO.
export class KpiReportSessionRequestDTO {
  contextKey: string;

  constructor(contextKey: string = '') {
    this.contextKey = contextKey;
  }
}

// The Copilot session that holds a finished KPI report's thread. Mirrors the backend KpiReportSessionDTO.
export class KpiReportSessionDTO {
  sessionId: number;

  constructor() {
    this.sessionId = 0;
  }
}
